export const CalendlyType = {
  INITIAL_CLIENT_CALL: 'initial_client_call',
  FOLLOW_UP_CALL: 'follow_up_call',
  DEFAULT: 'default',
};
